import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AuthService } from '../user/auth.service';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/take';
@Injectable()
export class PathGuard implements CanActivate {



  constructor(

    private router: Router,
    private location: Location


  ) { }
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | boolean {


    if (next.data && next.data.lockToPath && location && location.pathname) {
      if (location.pathname.toLowerCase() != next.data.lockToPath) {
      //  return false;
      return;
      }
    }

    return true;
  }
}



// WEBPACK FOOTER //
// ./src/app/guards/path.guard.ts